const gfpCostKey = "GfpCost";
const penceInPound = 100;

// Totals the GFP cost frozen on the given items of a completed Tacho Infringements topic. The sum is
// taken in whole pence so adding the two-place cost strings cannot drift. Items without a cost,
// and anonymised items, which carry no captured facts, add nothing. Returns null when no item
// carries a GFP cost field at all, as for a review completed before costs were captured.
export function sumTachoGfpCost(items) {
    const costFields = (items ?? [])
        .map((item) => (item?.data?.fields ?? []).find((field) => field.key === gfpCostKey))
        .filter((field) => field != null);

    if (costFields.length === 0) {
        return null;
    }

    const totalPence = costFields
        .filter((field) => field.value != null && field.value !== "")
        .reduce((total, field) => total + Math.round(Number(field.value) * penceInPound), 0);

    return totalPence / penceInPound;
}
